// helpers/navigateTo.js
export function navigateTo(item, props) {
  if (!item?.url) return;

  // extraemos navigate desde props
  const navigate = props.navigate;

  if (!navigate) {
    console.warn(
      "navigateTo: props.navigate no existe. Asegúrate de envolver la clase con withNavigate."
    );
    return;
  }
  if (!item?.id) {
    navigate(`/balance-show?url=${item.url}`, { state: { url: item.url } });
  } else {
    navigate(`/balance-detail?url=${item.url}&id=${item.id}`, {
      state: { url: item.url, id: item.id },
    });
  }
}
